<template lang="pug">
  tr.row.row-title
    th.col.blank
    th.col.check
      label.checkbox
        input(type="checkbox", :checked="checked", :disabled="isGlobalLocked", @click="check")
    th.col
      span 施設名
    th.col
      span ジャンル
    th.col
      span 電話番号
    th.col
      span 市区町村
    th.col
      span 申請者氏名
    th.col
      span 申請法人
    th.col
      span 開業基準日
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['checked'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
    },
    methods: {
      check (event) {
        this.$emit('check', { event })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessTableHeader.vue